import Vue from 'vue';
import store from './store/index';
import i18n from './i18n';
import moment from 'moment';
import gloading from '@/utils/gloading';
import dataExport from '@/utils/dataExport';
import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver';
import api from './services/data.services';
import router from './router';
import infoMsgs from './utils/infoMsgs';

function checarAcao(acao, isMenu) {
  //if (acao == null && store.state.user.info.root == true) return true;
  //if (store.state.user.info.root == true || store.state.user.permissoes.includes(acao)) return true;
  if (store.state.user.permissoes.includes(acao)) return true;
  return false;
}

//Função atualizada para utilizar novo método do javascript de conversão
function formatCurrency(value, options = {}, method) {
  let empresaDetalhes = getDetalhesPaises();
  let opt = { prefix: 'R$ ', dynamicCurrency: false, toOdin: false, precision: 2, ...options };
  let output = opt.toOdin ? parseFloat(value) / 100 : parseFloat(value) || 0;

  const intlOptions = {
    style: opt.dynamicCurrency ? 'currency' : 'decimal',
    currency: opt.dynamicCurrency ? empresaDetalhes['iso-4217'] : undefined,
    minimumFractionDigits: opt.precision,
    maximumFractionDigits: opt.precision
  };

  const formattedValue = output.toLocaleString(empresaDetalhes.idiomas, intlOptions);

  return `${opt.dynamicCurrency ? '' : opt.prefix}${formattedValue}`;
}

function currencyPerLanguage() {
  let empresaDetalhes = getDetalhesPaises();
  const formatter = new Intl.NumberFormat(empresaDetalhes.idiomas, {
    style: 'currency',
    currency: empresaDetalhes['iso-4217']
  });
  const parts = formatter.formatToParts(0);
  const currencySymbol = parts.find((part) => part.type === 'currency');
  const prefix = `${currencySymbol.value} `;

  return prefix;
}

function getDetalhesPaises() {
  let detalhesPaises = store.state.user.info?.empresa__paises_detalhes
    ? JSON.parse(store.state.user?.info?.empresa__paises_detalhes)
    : {
        idiomas: 'pt-br',
        'iso-4217': 'BRL'
      };
  return detalhesPaises;
}

// Condição para acessar a tela de gestor
function validarPermissaoGestor(route, inGestor = false) {
  if (route.path == '/principal/cadastros/gestor/listar' || inGestor) {
    let permissoes_negocio = store.state.user.info.permissoes_negocio;
    let empresa = getIdEmpresa();

    if (permissoes_negocio) {
      permissoes_negocio = JSON.parse(permissoes_negocio);
      let empresa_logada = permissoes_negocio.filter((p) => p.idEmpresa === empresa)[0];

      // Se tiver localidade em permissões negócio, deve ocultar a tela de gestores.
      if (empresa_logada?.localidades && empresa_logada?.localidades?.length) {
        // Só habilitar gestores se não tiver localidade
        return false;
      }
    }
  }

  return true;
}

/**
 * @deprecated por favor use a função $util.formatCurrency(value);
 */
function formatMoney(value, prefix = 'R$ ', toOdin) {
  // return '$';
  return formatCurrency(value, { prefix, toOdin, dynamicCurrency: true });
}

function odinToDate(datetime) {
  var jsDate;

  if (datetime.length == 8) {
    jsDate = new Date(datetime.slice(0, 4), datetime.slice(4, 6) - 1, datetime.slice(6, 8));

    return jsDate;
  }

  if (datetime.length == 14) {
    jsDate = new Date(
      datetime.slice(0, 4),
      datetime.slice(4, 6) - 1,
      datetime.slice(6, 8),
      datetime.slice(8, 10),
      datetime.slice(10, 12),
      datetime.slice(12, 14)
    );

    return jsDate;
  }
}

function getDateFormat() {
  if (i18n.locale == 'en') {
    return 'yyyy-MM-dd';
  } else {
    return 'dd/MM/yyyy';
  }
}

/**
 *
 * @param {date | moment} date
 * @param {object} {en: 'YYYY-MM', default: 'MM/YYYY' }
 * @returns string data formatada seguindo o que foi informado.
 * Exemplo i18n.en: YYYY-MM, se i18n.es ou i18n.pt-BR: MM/YYYY
 * @example
 * formatDateByPattern(date,{en: 'YYYY-MM', default: 'MM/YYYY' }) // '09/2021' para 'PT-BR' ou '2021-09' para 'en'
 * formatDateByPattern(date,{en: 'YYYY-MM-DD', default: 'DD/MM/YYYY' }) // '01/09/2021' para 'PT-BR' ou '2021-09-01' para 'en'
 * //Caso o segundo parametro não seja informado devolver a data formatada com horas e minutos.
 */
function formatDateByPattern(date, format = { default: '', en: 'YYYY-MM-DD HH:mm:ss' }) {
  if (!date) return '';
  const i18nFormat = format[i18n.locale] || format.default || 'DD/MM/YYYY HH:mm:ss';
  return moment(date).locale(i18n.locale).format(i18nFormat);
}

function formatDate(data, locale) {
  const appLocale = getLocale(locale || i18n.locale, true);
  return moment(data).format(appLocale);
}

export function getLocale(locale = i18n.locale, onlyDate) {
  const localeToFormat = {
    'pt-BR': 'DD/MM/YYYY HH:mm:ss',
    es: 'DD/MM/YYYY HH:mm:ss',
    en: 'YYYY-MM-DD hh:mm:ss a'
  };
  const localeToFormatToDate = {
    'pt-BR': 'DD/MM/YYYY',
    es: 'DD/MM/YYYY',
    en: 'YYYY-MM-DD'
  };
  return onlyDate ? localeToFormatToDate[locale] : localeToFormat[locale];
}

function detectarMascaraData(timezone = 'America/Recife', locale = i18n.locale) {
  const dataExemplo = new Date(Date.UTC(2025, 0, 2, 13, 5, 7)); // 02/01/2025 13:05:07 UTC

  const formatador = new Intl.DateTimeFormat(locale, {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });

  const partes = formatador.formatToParts(dataExemplo);

  let mascara = '';
  for (const part of partes) {
    if (part.type === 'day') mascara += 'DD';
    else if (part.type === 'month') mascara += 'MM';
    else if (part.type === 'year') mascara += 'YYYY';
    else if (part.type === 'hour') mascara += 'HH';
    else if (part.type === 'minute') mascara += 'mm';
    else if (part.type === 'second') mascara += 'ss';
    else if (part.type === 'literal') mascara += part.value;
    // ignorar outros tipos como 'timeZoneName' etc
  }

  return mascara;
}

function formatDateTime(data, locale) {
  const appLocale = getLocale(locale || i18n.locale);
  if (data === undefined) {
    return '';
  }
  return moment(data).format(appLocale);
}

function onlyNumbers(str) {
  return str !== null || undefined ? str.replace(/\D/g, '') : null;
}

function stringToNumber(number, defaultValue = 0, arrayConfig, options = {}) {
  const opt = { ...options };
  const output = number;
  if (arrayConfig && arrayConfig.isArray) {
    if (arrayConfig.arr.length === 0) return [];
    if (arrayConfig.keys) {
      return arrayConfig.arr.map((obj) => {
        let objNew = {};
        arrayConfig.keys.forEach((key) => {
          objNew[key] = stringToNumber(obj[key]);
        });
        return {
          ...obj,
          ...objNew
        };
      });
    } else {
      let result = [];
      const keys = Object.keys(arrayConfig.arr[0]);
      arrayConfig.arr.forEach((obj) => {
        let newObj = {};
        keys.forEach((key) => {
          newObj[key] = stringToNumber(obj[key]);
        });
        result.push({
          ...obj,
          ...newObj
        });
      });
      return result;
    }
  } else {
    const numberFormated = opt.precision ? Number(((output || 0) / 1).toFixed(opt.precision)) : Number(output);
    return numberFormated || defaultValue;
  }
}

function sortArray(arr = [], key) {
  if (key) {
    arr.sort((a, b) => {
      a = String(a[key]).toLowerCase();
      b = String(b[key]).toLowerCase();

      if (a > b) {
        return 1;
      }
      if (b > a) {
        return -1;
      }
      return 0;
    });
    return arr;
  }
  arr.sort((a, b) => {
    a = a.toLowerCase();
    b = b.toLowerCase();

    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  });
  return arr;
}

function getTheme() {
  return localStorage.getItem('atena-theme') || process.env.VUE_APP_THEME;
}

function unixToIso(rawDate) {
  // Extrai as partes da data
  const year = rawDate.slice(0, 4);
  const month = rawDate.slice(4, 6);
  const day = rawDate.slice(6, 8);
  const hour = rawDate.slice(8, 10);
  const minute = rawDate.slice(10, 12);
  const second = rawDate.slice(12, 14);

  // Cria um objeto Date (atenção: meses em JavaScript vão de 0 a 11)
  const dateObj = new Date(Date.UTC(year, month - 1, day, hour, minute, second));

  // Converte para string ISO
  const isoString = dateObj.toISOString().substring(0, 19);

  return isoString;
}

function switchThemeDark() {
  const body = document.getElementsByTagName('body')[0];
  if (getTheme() != 'atena-dark') {
    body.removeAttribute('class');
  }
  body.classList.toggle('atena-dark');
  localStorage.setItem('atena-theme', body.className);
}

function setTheme(theme) {
  const body = document.getElementsByTagName('body')[0];
  body.removeAttribute('class');
  if (theme) {
    body.classList.add(`${theme}`);
  }
  localStorage.setItem('atena-theme', body.className);
  store.state.app.theme = body.className;
}

function getTipoUsuario(id) {
  let tipos = ['', i18n.t('Cambista'), i18n.t('Operador'), i18n.t('Apostador'), i18n.t('Totem')];
  return tipos[id];
}

function getIdEmpresa() {
  return store.state.user.info.id_empresa;
}

function getIdLocalidades() {
  return store.state.user.info.localidades;
}

function isSameDay(stringData) {
  if (!stringData) return;

  return moment()
    .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
    .isSame(moment(stringData).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }), 'days');
}

function formatPin(value) {
  return value
    .split(/(\d{4})/)
    .filter((e) => e)
    .join(' ');
}

function translateMetodoPagamento(input, id_grupo = null) {
  if (input == null) {
    return '';
  }

  var resultado = '';

  switch (input) {
    case 'accountType':
      resultado = id_grupo
        ? id_grupo == 5
          ? i18n.t('Tipo Chave Pix')
          : i18n.t('Tipo de Conta')
        : i18n.t('Tipo de Conta');
      break;
    case 'accountHolder':
      resultado = i18n.t('Beneficiário');
      break;
    case 'accountHolderDocument':
      resultado = 'CNPJ';
      break;
    case 'bankAccount':
      resultado = id_grupo ? (id_grupo == 5 ? i18n.t('Chave Pix') : i18n.t('Conta')) : i18n.t('Conta');
      break;
    case 'bankAgency':
      resultado = i18n.t('Agência');
      break;
    case 'bankName':
      resultado = i18n.t('Banco');
      break;
    case 'urlInternetBanking':
      resultado = 'Internet Banking';
      break;
    case 'boletoLink':
      resultado = i18n.t('Link Boleto');
      break;
    case 'boletoNumber':
      resultado = i18n.t('Linha Digitável');
      break;
    case 'bankAccountFgSavings':
      resultado = i18n.t('Poupança');
      break;
    case 'bankBranch':
      resultado = i18n.t('Agência');
      break;
    case 'beneficiaryLastname':
      resultado = i18n.t('Sobrenome');
      break;
    case 'beneficiaryName':
      resultado = i18n.t('Nome');
      break;
    case 'cpf':
      resultado = 'CPF';
      break;
    case 'email':
      resultado = 'E-mail';
      break;
    case 'idBank':
      resultado = i18n.t('ID Banco');
      break;
    case 'operationType':
      resultado = i18n.t('Tipo de Operação');
      break;
    case 'phone':
      resultado = i18n.t('Telefone');
      break;
    case 'userPSPID':
      resultado = i18n.t('ID Usuário');
      break;
    case 'userPSPSecureID':
      resultado = 'Secure ID';
      break;
    case 'codeErrPSP':
      resultado = i18n.t('Código de Erro');
      break;
    case 'msgErrPSP':
      resultado = i18n.t('Mensagem de Erro');
      break;
    case 'boletoDigitableLine':
      resultado = i18n.t('Linha Digitável');
      break;
    case 'transactionID2':
      resultado = 'NSU';
      break;
    default:
      resultado = input;
  }

  return resultado;
}

function getEnv() {
  return process.env.VUE_APP_ENV || 'dev';
}

function removeItemFromArray(array, item) {
  var i = array.length;

  while (i--) {
    if (array[i] === item) {
      array.splice(i, 1);
    }
  }
}

function formatDateDB(date) {
  return moment(date).format('YYYY-MM-DD');
}

function formatDateWithWeek(date) {
  moment.locale(i18n.locale);
  return moment(date).format('ddd - L').toUpperCase();
}

/**
 * Recebe um objeto com os dados do arquivo (filename, contentType e fileData)
 * e faz o download do arquivo.
 *
 * @param {Object} data - Dados do arquivo a ser baixado.
 *                        Deve possuir as seguintes propriedades:
 *                        - filename: nome do arquivo
 *                        - contentType: tipo MIME do arquivo
 *                        - fileData: dados do arquivo em Base64
 * @returns {void}
 * OBS: PODE VER A FUNÇÃO DO BACK QUE JA RETORNA ESSE PADRÃO: EntityController->fileXmlSigap();
 */
function downloadFile(data) {
  // Decodifica Base64 para string binária
  const byteCharacters = atob(data.fileData);
  const byteNumbers = new Array(byteCharacters.length);

  // Converte cada caractere em código numérico
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  // Cria um array de bytes
  const byteArray = new Uint8Array(byteNumbers);

  // Cria um Blob com o tipo correto do arquivo
  const blob = new Blob([byteArray], { type: data.contentType });

  // Criar um link para baixar o arquivo
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = data.filename; // Usa o nome do arquivo vindo da resposta
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function isStrengthPassword(
  password = '',
  minLength = 8,
  checkSpecialChar = false,
  showMsg = true,
  checkUpperCase = true
) {
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumbers = /[0-9]/.test(password);
  const hasSpecialChars = /[!@#$%^&*()_+[\]{};':"\\|,.<>/?]/.test(password);

  if (password.length < minLength) {
    showMsg &&
      formWarn({
        msgTitle: 'Atenção',
        msgContent: 'The password need 8 or more characters'
      });
    return false;
  }

  if (!hasUpperCase && checkUpperCase) {
    showMsg &&
      formWarn({
        msgTitle: 'Atenção',
        msgContent: 'The password must have an uppercase character'
      });
    return false;
  }

  if (!hasLowerCase) {
    showMsg &&
      formWarn({
        msgTitle: 'Atenção',
        msgContent: 'Password must have a lowercase character'
      });
    return false;
  }

  if (!hasNumbers) {
    showMsg &&
      formWarn({
        msgTitle: 'Atenção',
        msgContent: 'Password must have a number'
      });
    return false;
  }

  if (checkSpecialChar && !hasSpecialChars) {
    showMsg &&
      formWarn({
        msgTitle: 'Atenção',
        msgContent: 'Password must have a special character'
      });
    return false;
  }

  return true;
}

function showWeekFromDate(date, format = 'long') {
  moment.locale(i18n.locale);
  if ((format = 'long')) {
    return moment(date).format('dddd');
  } else if ((format = 'short')) {
    return moment(date).format('ddd');
  }
}

/**
 * @param { str } $ rebece a string Ex.:'$ 100.150,15'
 * @returns valor em float.
 * Recebe a string no formato '$ 100.150,15' e retorna 100150.15
 * @example
 * formatMoneyToFloat('$ 100.150,15') // 100150.15
 */
function formatMoneyToFloat(str) {
  if (typeof str == 'string') {
    let retorno = parseFloat(str.slice(2).replace('.', '').replace(',', '.'));
    if (!isNaN(retorno)) return retorno;
    else return str;
  }
}
const replaceSpecialChar = (inputString) => {
  // Define a regular expression to match special characters
  var specialCharacterRegex = /[!@#$%^&´`=*()_+{}\[\]:;<>,.?~\\|-À-ü]|\'|\"/g;

  // Use the replace method to replace all special characters with an empty string
  let result = inputString.replace(specialCharacterRegex, '-');

  return result;
};

/**
 * Formata um nome de tag para ser válido em XML.
 * - Converte "#" em "id".
 * - Remove espaços extras, acentos e caracteres especiais.
 * - Converte para minúsculas e capitaliza a letra após cada espaço.
 * - Remove todos os espaços no final.
 *
 * @param {string} tagName - O nome da tag que será formatado.
 * @returns {string} - O nome da tag formatado.
 */
// prettier-ignore
const formatXmlTag = (tagName) => {
  return tagName === '#'
    ? 'id'
    : tagName
        .trim()                                                     // Remove espaços antes e depois
        .normalize('NFD')                                           // Normaliza para decompor caracteres acentuados
        .replace(/[\u0300-\u036f]/g, '')                            // Remove os caracteres de acento
        .toLowerCase()                                              // Converte para minúsculas como base
        .replace(/[^a-z0-9 ]/g, ' ')                                // Remove caracteres especiais, mantém espaços
        .replace(/\s+./g, (match) => match.trim().toUpperCase())    // Capitaliza a letra após cada espaço
        .replace(/\s+/g, '');                                       // Remove todos os espaços
};

function compareDifferenceDates(dateBefore, dateAfter, hours) {
  var difference = Math.round(dateAfter - dateBefore) / (1000 * 60 * 60);
  return difference > hours;
}

function validateDates(
  dataInicio,
  dataFim,
  intervalDias,
  intervalDiasInMonths,
  isLimiteDays,
  ignoreEndDateLimit,
  customMsg,
  typeList,
  disallowEndDateToday
) {
  const intervalMaxTransactionals =
    intervalDias || store.state.user.configEmpresa?.intervalo_max_transacional || 31;
  const intervalMaxTickets = intervalDias || store.state.user.configEmpresa?.intervalo_max_bilhete || 7;
  const intervalMaxReports = intervalDias || store.state.user.configEmpresa?.intervalo_max_relatorio || 180;
  const intervalMax = !typeList
    ? intervalDias
    : typeList === 'report'
    ? intervalMaxReports
    : typeList === 'bilhete'
    ? intervalMaxTickets
    : intervalMaxTransactionals;
  const actualDate = moment().set({ h: 0, m: 0, s: 0, ms: 0 });
  const momentInicio = moment(dataInicio).set({ h: 0, m: 0, s: 0, ms: 0 });
  const momentFim = moment(dataFim).set({ h: 0, m: 0, s: 0, ms: 0 });
  const months = Math.trunc(intervalMax / 30);

  const msgOptions = {
    1: 'Selecione uma data inicial válida',
    2: 'Selecione uma data final válida',
    3: 'Defina uma Data Inicial e Final Válida',
    4: 'Defina uma Data Final maior que a Data Inicial',
    5: 'A Data fim não pode ser maior que a atual',
    6: 'Defina um período de no máximo {count} {unit}',
    7: 'Defina um período dentro dos últimos {count} {unit}',
    8: 'A Data fim não pode ser igual ou maior que a atual'
  };

  if (!dataInicio) {
    formWarn({
      msgTitle: 'Atenção',
      msgContent: customMsg && customMsg['1'] ? customMsg['1'] : msgOptions['1']
    });
    return false;
  }
  if (!dataFim) {
    formWarn({
      msgTitle: 'Atenção',
      msgContent: customMsg && customMsg['2'] ? customMsg['2'] : msgOptions['2']
    });
    return false;
  }

  if (dataInicio == '' && dataFim == '') {
    formWarn({
      msgTitle: 'Atenção',
      msgContent: customMsg && customMsg['3'] ? customMsg['3'] : msgOptions['3']
    });
    return false;
  }

  if (momentInicio.isAfter(momentFim)) {
    formWarn({
      msgTitle: 'Atenção',
      msgContent: customMsg && customMsg['4'] ? customMsg['4'] : msgOptions['4']
    });
    return false;
  }

  if (!ignoreEndDateLimit && momentFim > actualDate) {
    formWarn({
      msgTitle: 'Atenção',
      msgContent: customMsg && customMsg['5'] ? customMsg['5'] : msgOptions['5']
    });
    return false;
  }

  if (disallowEndDateToday && momentFim.isSameOrAfter(actualDate, 'day')) {
    formWarn({
      msgTitle: 'Atenção',
      msgContent: customMsg && customMsg['8'] ? customMsg['8'] : msgOptions['8']
    });
    return false;
  }

  if (!isLimiteDays) {
    if (momentFim.diff(momentInicio, 'days') > intervalMax) {
      formWarn({
        msgTitle: 'Atenção',
        msgContent: !intervalDiasInMonths
          ? i18n.t(customMsg && customMsg['6'] ? customMsg['6'] : msgOptions['6'], {
              count: intervalMax,
              unit: i18n.t(`dia${intervalMax !== 1 ? 's' : ''}`)
            })
          : i18n.t(customMsg && customMsg['6'] ? customMsg['6'] : msgOptions['6'], {
              count: months,
              unit: i18n.t(months !== 1 ? 'meses' : 'mês')
            })
      });
      return false;
    }
  } else {
    if (actualDate.diff(momentInicio, 'days') > intervalMax) {
      formWarn({
        msgTitle: 'Atenção',
        msgContent: !intervalDiasInMonths
          ? i18n.t(customMsg && customMsg['7'] ? customMsg['7'] : msgOptions['7'], {
              count: intervalMax,
              unit: i18n.t(intervalMax > 1 ? 'dias' : 'dia')
            })
          : i18n.t(customMsg && customMsg['7'] ? customMsg['7'] : msgOptions['7'], {
              count: months,
              unit: i18n.t(months !== 1 ? 'meses' : 'mês')
            }),
        msgTranslate: false
      });
      return false;
    }
  }
  return true;
}

/**
 * Remove all null values from an object or array.
 *
 * @param {object|array} obj
 * @returns {object|array} obj with all null values removed
 */
function removeNulls(obj) {
  if (Array.isArray(obj)) {
    return obj.map(removeNulls).filter((value) => value !== null);
  } else if (typeof obj === 'object' && obj !== null) {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      const cleanedValue = removeNulls(value);
      if (cleanedValue !== null) {
        acc[key] = cleanedValue;
      }
      return acc;
    }, {});
  }
  return obj !== null ? obj : null;
}

// Valida se o tamanho do arquivo(b) é maior igual que o tamanho dado(MB)
function checkFileSizeAndName(file, showMsg = true, formatsAccepts) {
  // Busca o limite configurado na empresa, com fallback para 1MB
  const limiteConfigurado = store.state.user.configEmpresa?.limite_tamanho_imagem || 1;

  if (file && file.size) {
    const file_size_mb = parseInt(file.size) / (1024 * 1024);
    if (file_size_mb >= limiteConfigurado) {
      showMsg &&
        formWarn({
          msgTitle: 'Atenção',
          msgContent: `${i18n.t('O arquivo escolhido está acima do tamanho suportado', {
            size: file_size_mb.toFixed(2),
            limit: limiteConfigurado
          })}`,
          msgTranslate: false
        });

      return true;
    }
  }

  if (file?.type && formatsAccepts) {
    const formatsAcceptsArr = formatsAccepts.split(',');
    let type = file.type.split('/')[1];
    type === 'svg+xml' && (type = 'svg');

    if (!formatsAcceptsArr.includes(`.${type}`)) {
      formWarn({
        msgTitle: 'Atenção',
        msgContent: `${i18n.t('O arquivo deve ter um dos seguintes formatos')}: ${formatsAccepts}`,
        msgTranslate: false
      });
      return true;
    }
  }

  return false;
}

function validateFormEntity(filter, type) {
  if (!filter) {
    let message = '';
    switch (type) {
      case 0:
        message = i18n.t('Selecione uma empresa.');
        break;
      case 1:
        message = i18n.t('Selecione um Centro de Custo.');
        break;
      case 2:
        message = i18n.t('Selecione uma Localidade.');
        break;
      case 3:
        message = i18n.t('Selecione uma Seção.');
        break;
      case 4:
        message = i18n.t('Selecione uma Rota.');
        break;
      case 5:
        message = i18n.t('Selecione um Estabelecimento.');
        break;
      default:
        message = i18n.t('Existe um filtro necessário vazio.');
        break;
    }

    Vue.notify({
      group: 'notifications-default',
      type: 'error',
      title: i18n.t('Atenção'),
      text: message
    });
    return true;
  } else return false;
}

function formatIdStatusPin(input) {
  if (input == null) {
    return '';
  }
  var resultado = '';

  switch (input) {
    case 1:
      resultado = i18n.t('Disponível');
      break;
    case 2:
      resultado = i18n.t('Utilizado');
      break;
    case 3:
      resultado = i18n.t('Cancelado');
      break;
    case 4:
      resultado = i18n.t('Negado');
    default:
      resultado = input;
  }

  return resultado;
}

function isValidCPF(cpf) {
  if (cpf == null) return null;
  if (typeof cpf === 'undefined') return null;
  if (typeof cpf !== 'string') return false;
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false;
  cpf = cpf.split('');
  const validator = cpf.filter((digit, index, array) => index >= array.length - 2 && digit).map((el) => +el);
  const toValidate = (pop) =>
    cpf.filter((digit, index, array) => index < array.length - pop && digit).map((el) => +el);
  const rest = (count, pop) =>
    ((toValidate(pop).reduce((soma, el, i) => soma + el * (count - i), 0) * 10) % 11) % 10;
  return !(rest(10, 2) !== validator[0] || rest(11, 1) !== validator[1]);
}

function isValidCNPJ(cnpj) {
  if (!cnpj || typeof cnpj !== 'string') return false;

  cnpj = cnpj.replace(/\D/g, ''); // Remove caracteres não numéricos

  if (cnpj.length !== 14 || cnpj.split('').every((c) => c === cnpj[0])) return false; // Evita sequências como "11111111111111"

  const calc = (slice, pos) => {
    const weights = pos === 12 ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const sum = slice.reduce((acc, num, i) => acc + num * weights[i], 0);
    return sum % 11 < 2 ? 0 : 11 - (sum % 11);
  };

  const digits = cnpj.split('').map(Number);
  return calc(digits.slice(0, 12), 12) === digits[12] && calc(digits.slice(0, 13), 13) === digits[13];
}

function isValidDNI(dni) {
  if (dni == null) return false;

  let numero, letValid, letra;
  let expression_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;

  dni = dni.toUpperCase();

  if (expression_regular_dni.test(dni) === true) {
    numero = dni.substr(0, dni.length - 1);
    numero = numero.replace('X', 0);
    numero = numero.replace('Y', 1);
    numero = numero.replace('Z', 2);
    letValid = dni.substr(dni.length - 1, 1);
    numero = numero % 23;
    letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
    letra = letra.substring(numero, numero + 1);
    if (letra != letValid) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
}

function isValidCURP(curp) {
  if (curp == null || typeof curp !== 'string' || curp.length !== 18) return false;
  const regex =
    /^[A-Z]{1}[AEIOU]{1}[A-Z]{2}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])[HM]{1}(AS|BC|BS|CC|CL|CM|CS|CH|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d]{1}\d$/;

  return regex.test(curp);
}

// validação de senhas maior que 7 digitos
function passwordsValidation(passwd, passwd_confirmation) {
  if (passwd && passwd_confirmation) {
    if (passwd.length > 7 && passwd == passwd_confirmation) {
      return true;
    }
  }

  formWarn({
    msgTitle: 'Atenção',
    msgContent: `Informe uma senha válida`
  });

  return false;
}

function isValidSSN(ssn) {
  let regex = new RegExp(/^(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$/);

  if (ssn == null) return false;

  if (regex.test(ssn) == true) {
    return true;
  } else {
    return false;
  }
}

function isNullUndefinedOrEmpty(value) {
  return value === null || value === undefined || value === '';
}

function verifyMfa() {
  const mfaAccomplished = localStorage.getItem('mfa-accomplished') ? true : false;

  if (!mfaAccomplished) {
    formWarn({
      msgTitle: 'Atenção',
      msgContent: `Autenticação de múltiplas etapas necessária para realizar esta ação (MFA)`
    });
  }

  return mfaAccomplished;
}

/**
 * Verifica se MFA é obrigatório para uma operação específica baseado nas permissões da empresa.
 * @param {string} operation - Nome da operação (ex: 'lancamentoManual', 'aprovarSaque', 'promo', etc.)
 * @returns {boolean} - true se MFA é obrigatório, false se não é
 */
function requireMFAForOperation(operation) {
  const info = JSON.parse(localStorage.getItem('info') || '{}');
  let permissoes = info.empresa__permissoes || {};

  // Se permissoes for string, faz parse
  if (typeof permissoes === 'string') {
    try {
      permissoes = JSON.parse(permissoes);
    } catch (e) {
      permissoes = {};
    }
  }

  // Se não definido ou true, exige MFA; Se false, não exige
  return permissoes?.requireMFA?.[operation] !== false;
}

function isValidCssUnity(medida = '') {
  const regexMedida = /^\d+(\.\d+)?(px|em|rem|%|in|cm|mm|ex|pt|pc|ch|vw|vh|vmin|vmax)$/;
  return regexMedida.test(medida);
}

function percentage(input, onlySymbol) {
  let percent = input * 100;
  if (onlySymbol) percent = input;
  return Number(percent).toFixed(2) + '%';
}

/**
 *
 * @param {object} user
 * @param {array} attributes
 * @returns Object
 * @example
 * pickOrderObj({name: "Marcos", phone: '(99) 99999-9999', age: 18, gender: "M"},['age','gender','name'])
 * {age: 18, gender: "M", name: 'Marcos'} // output
 */
function pickOrderObj(user = {}, attributes = []) {
  const keys = Object.keys(user);
  const fieldsOrdered = [];

  keys.forEach((key) => {
    if (attributes.includes(key)) {
      const index = attributes.findIndex((att) => att === key);
      const field = { [key]: user[key] };
      fieldsOrdered.push({ field, index });
    }
  });

  return fieldsOrdered
    .sort((a, b) => a.index - b.index)
    .reduce(
      (obj, item) => ({
        ...obj,
        ...item.field
      }),
      {}
    );
}

function getDateLang() {
  if (i18n.locale == 'en') {
    return new Object({
      language: 'English',
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],
      monthsAbbr: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      rtl: false,
      ymd: false,
      yearSuffix: ''
    });
  } else if (i18n.locale == 'pt-BR') {
    return new Object({
      language: 'Português',
      months: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro'
      ],
      monthsAbbr: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      days: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      rtl: false,
      ymd: false,
      yearSuffix: ''
    });
  } else if (i18n.locale == 'es') {
    return new Object({
      language: 'Español',
      months: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre'
      ],
      monthsAbbr: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dez'],
      days: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
      rtl: false,
      ymd: false,
      yearSuffix: ''
    });
  }
}

function dateToOdin(datetime, isDateTime) {
  var odinDate = new Date(datetime.getTime() - datetime.getTimezoneOffset() * 60000)
    .toJSON()
    .replace(/[^\d]/g, '');

  if (isDateTime) {
    return odinDate.slice(0, 14);
  } else {
    return odinDate.slice(0, 8);
  }
}

const cpfValidation = (inputCPF) => {
  var soma = 0;
  var resto;

  inputCPF = `${inputCPF}`.replaceAll('.', '').replaceAll('-', '');

  if (inputCPF == '00000000000') return false;
  if (!/^\d+$/.test(inputCPF)) return false;
  for (let i = 1; i <= 9; i++) soma = soma + parseInt(inputCPF.substring(i - 1, i)) * (11 - i);
  resto = (soma * 10) % 11;

  if (resto == 10 || resto == 11) resto = 0;
  if (resto != parseInt(inputCPF.substring(9, 10))) return false;

  soma = 0;
  for (let i = 1; i <= 10; i++) soma = soma + parseInt(inputCPF.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;

  if (resto == 10 || resto == 11) resto = 0;
  if (resto != parseInt(inputCPF.substring(10, 11))) return false;
  return true;
};

function emailValidation(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

function getTipoTemplateExtrato(movimento) {
  const template = {
    bilhete: 'bilhete',
    slot: { default: 'slot', transacao: 'transacao_slot' },
    lotericos: 'lotericos'
  };
  let result = '';
  if (movimento) {
    if ([1, 2, 4].includes(movimento.idTipoTransExtrato)) {
      result = template.bilhete;
    } else if ([8].includes(movimento.idTipoTransExtrato)) {
      result = template.slot.default;
    } else if ([10].includes(movimento.idTipoTransExtrato)) {
      if (movimento.descricao.search('slot') != -1) {
        result = template.slot.transacao;
      } else if (movimento.descricao.search('Lotéricos') != -1) {
        result = template.lotericos;
      } else {
        result = template.bilhete;
      }
    }
  } else if (movimento.descricao.search('Lotéricos') != -1) {
    result = template.lotericos;
  }

  return result;
}
function isValidDomain(domain) {
  const domainPattern = /^(https:\/\/)?([a-zA-Z0-9-_]{1,63}\.)+[a-zA-Z]{2,6}(\/[a-zA-Z0-9-_\/]*)?$/;
  return domainPattern.test(domain);
}
function formWarn({ msgTitle, msgContent, msgTranslate = true, type, duration }) {
  Vue.notify({
    group: 'notifications-default',
    type: type || 'warn',
    title: i18n.t(msgTitle),
    text: msgTranslate ? i18n.t(msgContent) : msgContent,
    duration: duration || 5000
  });
}
function chunk(arr, size) {
  if (!arr) return [];

  const length = Math.ceil(arr.length / size);

  return Array.from({ length }, (v, i) => arr.slice(i * size, i * size + size));
}

function monthsFromDate(date, dateInitFormat) {
  return moment().diff(moment(date, dateInitFormat), 'days') / 30;
}

function trimString(txt = '') {
  txt = txt.trim();
  txt = txt.replaceAll('\t', '');
  txt = txt.replaceAll('\n', '');
  return txt;
}

function brToFloat(str) {
  if (typeof str === 'string' && str !== '0,00') {
    str = str.replace(/\./g, '');
    str = parseFloat(str.replace(/,/g, '.'));
    return str;
  } else if (typeof str === 'number') {
    return str;
  } else return null;
}

function IsJsonString(str, allowNull) {
  if (isNaN(str) === false) {
    return false;
  }
  if (allowNull && str === null) {
    return true;
  } else {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
  }
  return true;
}

function abreviate(text = '', maxlength = 16) {
  if (text.length > maxlength) {
    let start = text.substring(0, 8);
    let end = text.substring(text.length - 9, text.length);

    return start + '...' + end;
  }

  return text;
}

function getDateTimeStamp(datestring, return_time = false) {
  if (datestring && (datestring.includes('-') || datestring.includes('/') || datestring.includes(' '))) {
    return moment(datestring).format(`YYYYMMDD${return_time ? 'HHmmss' : ''}`);
  }
  return datestring;
}

function fixedFloat(val, fix_to = 2) {
  let fixed_value = parseFloat(val || 0).toFixed(fix_to);
  return parseFloat(fixed_value);
}

function isAlphaNumeric(str) {
  let validChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  for (let i = 0; i < str.length; i++) {
    if (!validChars.includes(str[i])) {
      return false;
    }
  }
  return true;
}

// Formatação de data considerando timezone
function formatDateByTimezone(
  date_string,
  formato = 'DD/MM/YYYY HH:mm',
  considera_timezone = true,
  oper = 'subtract',
  options = {}
) {
  const { maxMiliseconds } = options;

  let date = moment(date_string);
  let formatoDate = formato;

  if (considera_timezone) {
    date = date[oper](new Date().getTimezoneOffset() / 60, 'hours');
  }

  if (maxMiliseconds) {
    formatoDate = String(formatoDate).replace(/(\.).*$/, (match) => '.'.padEnd(match.length, '9'));
  }

  return date.format(formatoDate);
}

function stringToDate(dateTime) {
  let stringdateTime = dateTime.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1-$2-$3 $4:$5:$6');
  return moment(stringdateTime).subtract(3, 'hour').toDate();
}

/**
 * @param {string} odd Entrada sempre em decimal (ex: "3.15")
 * @param {int} tipo 1 = Decimal (Default) / 2 = Americana
 * @returns number odd formatada seguindo o que foi informado.
 * @example
 * formatDateByPattern("1.5", 1) // "1.5"
 * formatDateByPattern("1.5", 2) // para Odd americana "-200"
 * //Caso o segundo parametro não seja informado devolve a odd original em decimal.
 */
export const converterOdds = (odd, tipo = 1) => {
  let novaOdd = parseFloat(odd);
  if (tipo == 2) {
    if (novaOdd >= 2.0) {
      novaOdd = (novaOdd - 1) * 100;
    } else {
      novaOdd = -100 / (novaOdd - 1);
    }
    novaOdd = novaOdd.toFixed(0);
  }
  return novaOdd.toFixed(2);
};

function dateIsBefore(date, dateCompare) {
  const momentDate = moment(date).set({ h: 0, m: 0, s: 0, ms: 0 });
  const momentCompare = moment(dateCompare).set({ h: 0, m: 0, s: 0, ms: 0 });
  return momentDate.isBefore(momentCompare);
}

function odinErrorTranslate(error) {
  if (error.search('Erro Modulo Core:') !== -1) {
    return error.split(':')[1];
  }
  return error;
}

function validaCotacaoMax(cotacoes) {
  const cotacao_maxima = parseFloat(JSON.parse(localStorage.getItem('info')).empresa__cotacao_maxima);
  let cotacaoAtingida = false;
  cotacoes.forEach((cotacao) => {
    if (parseFloat(cotacao) > cotacao_maxima) {
      formWarn({
        msgTitle: 'Atenção',
        msgContent: `Percentual de cotação superior a cotação máxima(${cotacao_maxima}) definida para a empresa`,
        type: 'warn'
      });
      cotacaoAtingida = true;
      return;
    }

    /// Validando limite do campo do banco de dados NUMERIC(5,2)
    if (parseFloat(cotacao) > 99999) {
      formWarn({
        msgTitle: 'Atenção',
        msgContent: `Percentual de cotação superior a cotação máxima suportada`,
        type: 'warn'
      });
      cotacaoAtingida = true;
      return;
    }
  });
  return cotacaoAtingida;
}

/**
 * @param {object} h Objeto de criação de elementos no dom (ex: atribuir a uma variavel e passar this.$createElement)
 * @param {object} bv instancia do modal
 * @param {string} options padrões de mensagens pré-criados no build (patterns: ['confirm-back']) ou body personalizado pode ser passado nesse obj
 * @returns O elemento body contruido para passar ao modal
 * @example
 * buildBodyModal(this.$createElement, {pattern:'confirm-back', body:{message:'',highlightText:'', helpText:''}})
 */
function buildConfirmModal(h, bv, options, cb) {
  const { pattern, body, config } = options || { pattern: 'default' };
  const build = {
    'confirm-back': {
      title: `${i18n.t(`Sair`)}`,
      message: `${i18n.t(`Deseja sair da página, sem salvar as alterações`)}?`,
      helpText: `${i18n.t('Todas as alterações serão perdidas')}`
    },
    default: {
      title: `${i18n.t(`Sair`)}`,
      message: `${i18n.t(`Deseja sair da página, sem salvar as alterações`)}?`,
      helpText: `${i18n.t('Todas as alterações serão perdidas')}`
    }
  };

  function verifyPattern() {
    if (pattern && Object.keys(build).includes(pattern)) {
      return pattern;
    }
  }
  const elementBody = h('div', { class: ['row'] }, [
    h('div', { class: ['col-12 d-flex align-itens-center', config?.textClass || ''] }, [
      ('span', (body && body.message) || build[verifyPattern()].message),
      h(
        'strong',
        { class: ['ml-1'] },
        body && body.highlightText
          ? body.highlightText
          : (build[verifyPattern()] && build[verifyPattern()].highlightText) || ''
      ),
      (pattern || body) &&
        ((body && body.helpText) || (build[verifyPattern()] && build[verifyPattern()].helpText)) &&
        h('b-icon', {
          class: ['h5 ml-1'],
          attrs: {
            id: 'tooltip-help-variant'
          },
          props: {
            icon: 'exclamation-circle-fill',
            variant: 'danger'
          }
        }),
      h(
        'b-tooltip',
        {
          props: {
            target: 'tooltip-help-variant',
            variant: 'danger'
          }
        },
        body && body.helpText ? body.helpText : (build[verifyPattern()] && build[verifyPattern()].helpText) || ''
      )
    ])
  ]);

  bv.msgBoxConfirm(elementBody, {
    title: body && body.title ? body.title : (build[verifyPattern()] && build[verifyPattern()].title) || '',
    size: (config && config.size) || 'md',
    buttonSize: (config && config.buttonSize) || 'md',
    okVariant: (config && config.okVariant) || 'primary',
    okTitle: i18n.t('Confirmar'),
    cancelTitle: i18n.t('Fechar'),
    footerClass: 'p-2',
    hideHeaderClose: false,
    autoFocusButton: 'ok'
  })
    .then((value) => {
      console.log('VALUE', value);

      cb && cb(value, null);
    })
    .catch((err) => cb && cb(null, err));
}

function isRoot() {
  return store.state.user.info.root;
}

function isAdmin() {
  return store.state.user.info.admin;
}

function isMonitor() {
  return store.state.user.info.monitor;
}

function exportComponent(idElement, isPrint, cb) {
  const prtHtml = document.querySelector('#' + idElement);
  let stylesHtml = '';
  for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
    stylesHtml += node.outerHTML;
  }

  if (isPrint) {
    if (idElement === 'printerQRcode') {
      html2canvas(prtHtml, { backgroundColor: 'white' }).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const WinPrint = window.open('', '_blank');
        WinPrint.document.write(`<img src="${imgData}" style="width:100%"/>`);
        WinPrint.document.close();

        WinPrint.onload = function () {
          WinPrint.focus();
          WinPrint.print();
          WinPrint.close();
        };
      });
    } else {
      const WinPrint = window.open('', '_blank');

      WinPrint.document.write(
        `<!DOCTYPE html>
          <html>
            <head>
            <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" />
              ${stylesHtml}
            </head>
            <body>
              ${prtHtml.innerHTML}
            </body>
          </html>`
      );
      WinPrint.document.close();

      WinPrint.onload = function () {
        WinPrint.focus();
        WinPrint.print();
        WinPrint.close();
      };
    }
  } else {
    html2canvas(prtHtml, { backgroundColor: 'white' }).then(function (canvas) {
      canvas.toBlob(function (blob) {
        const elem = new ClipboardItem({
          [blob.type]: blob
        });
        copyToClipBoard(
          elem,
          (success) => {
            if (success) {
              cb && cb(true);
            }
          },
          true
        );
      });
    });
  }
}

function hasSpecialChars(str = '') {
  let specials = /[^A-Za-z 0-9]/g;
  return specials.test(str);
}

function removeDuplicateByList(list, listKeys, isObject) {
  const result = isObject
    ? list.filter((obj, index, array) => array.findIndex((t) => objectIsSame(t, obj, listKeys)) == index)
    : list.filter((obj, index, array) => array.findIndex((t) => t === obj) == index);
  return result;
}

function unixToIso2(unix) {
  return moment.unix(unix).toISOString();
}

function objectIsSame(objA, objB, keys) {
  let isEqual;
  keys.forEach((key) => {
    objA[key] === objB[key] ? (isEqual = true) : (isEqual = false);
  });
  return isEqual;
}

// Máscara para telefones padrão brasileiro
// (00)00000-0000
// +00 (00) 00000-0000
function formatPhone(phone, isDDI) {
  if (!phone) return phone;
  let masked_phone = Array.from(`${phone}`);
  if (isDDI) {
    masked_phone.splice(0, 0, '+');
    masked_phone.splice(3, 0, ' (');
    masked_phone.splice(6, 0, ') ');
    masked_phone.splice(12, 0, '-');
  } else {
    masked_phone.splice(0, 0, '(');
    masked_phone.splice(3, 0, ') ');
    masked_phone.splice(9, 0, '-');
  }

  return masked_phone.toString().replaceAll(',', '');
}

function formatDateTimeLocal(d, f = 'YYYYMMDDHHmmss') {
  const dataAtual = moment(d);
  const utcOffsetAtual = moment().utcOffset();
  const dataComUtcOffsetAtual = moment(dataAtual).utcOffset(utcOffsetAtual);
  return dataComUtcOffsetAtual.format(f);
}

// Máscara para cpf
// 123.456.789-00
function formataCpf(valor) {
  return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
}

// Máscara para cnpj
// 12.345.678/1234-56
function formataCnpj(valor) {
  return valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
}

function mascaraAgencia(valor) {
  if (valor && valor.length > 4) {
    valor = valor.replace(/\D/g, '');
    return valor.replace(/^(\d{4})(\d{0,1})/, '$1-$2');
  }
  return valor;
}

function mascaraContaCorrente(valor) {
  if (valor) {
    valor = valor.replace(/\D/g, '');
    return valor.replace(/^(\d{5,8})(\d{1})$/, '$1-$2');
  }
  return valor;
}

const toLower = (to_lower = '') => {
  to_lower = to_lower.toLowerCase();
  to_lower = to_lower.replaceAll(' ', '-');

  return to_lower;
};

function slugify(str) {
  str = str.replace(/^\s+|\s+$/g, '');
  str = str.toLowerCase();

  const from = 'àáäâèéëêìíïîòóöôùúüûñçěščřžýúůďťň·/_,:;';
  const to = 'aaaaeeeeiiiioooouuuuncescrzyuudtn------';

  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str
    .replace('.', '-')
    .replace(/[^a-z0-9 -]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/\//g, '');

  return str;
}

function copyToClipBoard(elem, cb, isBlob, isText) {
  if (!navigator.clipboard) {
    if (isText) {
      var copyElement = document.createElement('textarea');
      copyElement.textContent = decodeURI(elem);
      var body = document.getElementsByTagName('body')[0];
      body.appendChild(copyElement);
      copyElement.select();
    } else {
      elem.select();
    }
    document.execCommand('copy');
    cb && cb(true);
  } else {
    isBlob
      ? navigator.clipboard
          .write([elem])
          .then(() => {
            cb && cb(true);
          })
          .catch(() => {})
      : navigator.clipboard
          .writeText(elem)
          .then(() => {
            cb && cb(true);
          })
          .catch(() => {});
  }
}

function removeArrayItem(item, array = []) {
  let arr = JSON.parse(JSON.stringify(array));
  const pos = arr.indexOf(item);
  if (pos >= 0) {
    arr.splice(pos, 1);
  }
  return arr;
}

// Une arrays sem duplicações
function union(item1, item2) {
  let unionArray = [];

  unionArray = Array.from(
    new Set([...(Array.isArray(item1) ? item1 : [item1]), ...(Array.isArray(item2) ? item2 : [item2])])
  );

  return unionArray;
}

function isSequential(numbers, justCheckIsBigger = false) {
  if (!Array.isArray(numbers) || numbers.length === 0) return false;

  for (let i = 1; i < numbers.length; i++) {
    if (justCheckIsBigger) {
      if (numbers[i] <= numbers[i - 1]) {
        return false;
      }
    } else {
      if (numbers[i] !== numbers[i - 1] + 1) {
        return false;
      }
    }
  }
  return true;
}

// Une objeto sem duplicações de chaves
function merge(item1, item2) {
  let mergeObject = {};

  mergeObject = {
    ...item1,
    ...item2
  };

  return mergeObject;
}

function emptyColumn(arr, columns) {
  let emptyColumns = [];
  // Checar nessas colunas se TODOS os resultados esão vazios
  columns.forEach((key) => {
    if (arr.every((item) => !Object.keys(item).includes(key) || !item[key])) {
      emptyColumns.push(key);
    }
  });

  return emptyColumns;
}

function makeRandomString(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  if (!isStrengthPassword(result, length, false, false)) {
    result = makeRandomString(length);
  }
  return result;
}

function rangeColor(value) {
  const valueNumber = stringToNumber(value);
  return valueNumber > 0 ? 'success' : valueNumber < 0 ? 'danger' : 'default';
}

export const allowedChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789. -_';

function isValidFileName(str = '') {
  for (const c of str) {
    if (!allowedChars.includes(c)) {
      return false;
    }
  }
  return true;
}

function generateRandomToken(size) {
  let token = '';
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < size; i++) {
    token += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return token;
}

const getUniques = (arr = []) => {
  return Array.from(new Set(arr));
};
// Debounce
const debounce = (func, wait = 800) => {
  let timeout;

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

function getObjectRaw(objmodel = {}) {
  const strObj = JSON.stringify(objmodel);
  return JSON.parse(strObj);
}

function validateDateTime(startDate, endDate, validateToday) {
  if (startDate > endDate) {
    formWarn({
      msgTitle: 'Atenção',
      msgContent: 'Defina uma Data Final maior que a Data Inicial'
    });
    return false;
  }

  if (endDate > new Date() && validateToday) {
    formWarn({
      msgTitle: 'Atenção',
      msgContent: 'A Data fim não pode ser maior que a atual'
    });
    return false;
  }
  return true;
}

const titleCase = (s) => s.replace(/^_*(.)|_+(.)/g, (s, c, d) => (c ? c.toUpperCase() : ' ' + d.toUpperCase()));

function validateTime(startTime, endTime) {
  const start = new Date(`1970-01-01T${startTime}`);
  const end = new Date(`1970-01-01T${endTime}`);
  return start < end;
}

function formatIdStatusBilhete(pin) {
  let result;
  if (pin.id_meio_pagamento == 1 || pin.id_meio_pagamento == 45) {
    pin.pendente ? (result = 1) : pin.impresso ? (result = 2) : (result = 3);
  } else {
    pin.pendente && pin.erro_psp
      ? (result = 4)
      : pin.pendente && !pin.erro_psp
      ? (result = 5)
      : pin.liberacao_manual
      ? (result = 6)
      : pin.efetivada
      ? (result = 7)
      : '';
  }
  return result;
}

function generateURLFile(file) {
  let fileSrc = URL.createObjectURL(file);
  setTimeout(() => {
    URL.revokeObjectURL(fileSrc);
  }, 1000);
  return fileSrc;
}

function getIdsPermissoesNegocios() {
  const permissoes_negocio = store.state.user.info.permissoes_negocio
    ? JSON.parse(store.state.user.info.permissoes_negocio)
    : null;
  const ids = permissoes_negocio ? permissoes_negocio.map((empresa) => empresa.idEmpresa) : null;
  return ids;
}

function checkCurrentRoute(compareRoute) {
  return router.currentRoute.path === compareRoute?.path || router.currentRoute.name === compareRoute?.name
    ? true
    : false;
}

// Usar esse padrão para voltar ou avançar as pages e caso necessário se deu sucesso na operação
function goToRouter(name, params, status) {
  let config = {
    name: name,
    params: {
      ...params,
      filtros: params?.filtros,
      page: params?.page,
      sucesso: status
    }
  };
  if (!status && !params) delete config.params;
  return router.push(config);
}

function removeEmptyFromObj(obj) {
  if (obj) {
    Object.keys(obj).forEach((key) => {
      if (obj[key] && typeof obj[key] === 'object') {
        this.removeEmptyFromObj(obj[key]);
        if (Object.keys(obj[key]).length === 0) {
          //se pai ficou sem filhos
          delete obj[key]; //remove pai
        }
      } else if (obj[key] === null || obj[key] === '' || obj[key] == undefined || obj[key] == 'undefined')
        delete obj[key];
    });
  }
}

function getPerfilBusiness(typeUser) {
  const types = {
    usuario: this.getEnv() === 'prod' ? 9 : 1,
    usuario_site: this.getEnv() === 'prod' ? 35 : 1,
    usuario_gestor: this.getEnv() === 'prod' ? 36 : 1,
    usuario_arrecadador: this.getEnv() === 'prod' ? 37 : 1
  };
  return types[typeUser];
}

function formatStatusBilhetePago(input) {
  const status = {
    1: { value: i18n.t('Pago'), class: 'badge badge-outline-success' },
    0: { value: i18n.t('A Receber'), class: 'badge badge-outline-danger' }
  };
  return status[input];
}

function formatStatusLogin(data) {
  const usuario = getObjectRaw(data);
  return usuario.excluido
    ? 'Excluído'
    : usuario.bloqueado
    ? 'Bloqueado'
    : usuario.configuracao?.emPausa
    ? 'Em Pausa'
    : 'Ativo';
}

function formatStatusBilheteMeioPago(input) {
  const status = {
    1: { value: i18n.t('Sim'), class: 'badge badge-secondary' },
    0: { value: i18n.t('Não'), class: 'badge badge-secondary' },
    '-1': { value: '--' }
  };
  return status[input];
}

function renomearChavesEmArray(arrayDeObjetos, regras) {
  return arrayDeObjetos.map((objeto) => {
    return Object.fromEntries(Object.entries(objeto).map(([chave, valor]) => [regras[chave] || chave, valor]));
  });
}

function gestorLotericoIsActive(input) {
  return (
    store.state.user.configEmpresa.gestorLoterico && store.state.user.configEmpresa.gestorLoterico.enable === true
  );
}

function autenticacaoBilheteV2(tipoVenda, id, autenticacao, valor) {
  let autenticacaoRetorno = '';
  if (valor) {
    valor = valor.replace(/\./g, '');
  }

  if (tipoVenda == 1) {
    const autenticacaoCortada = autenticacao.substring(0, 10);
    autenticacaoRetorno = `${tipoVenda}.${id}.${valor}.${autenticacaoCortada}.`;
  } else {
    autenticacaoRetorno = `${tipoVenda}.${autenticacao}.`;
  }

  //Essa parte é para calcular os dígitos verificadores
  const digitoUm = calculaDigito(autenticacaoRetorno);
  autenticacaoRetorno = autenticacaoRetorno + digitoUm;
  const digitoDois = calculaDigito(autenticacaoRetorno);
  autenticacaoRetorno = autenticacaoRetorno + digitoDois;
  return autenticacaoRetorno;
}

function calculaDigito(valor) {
  valor = valor.replace(/\./g, '');
  let position = valor.length;
  let sum = 0;
  for (const r of valor) {
    sum += parseInt(r) * position;
    position--;
    if (position < 2) {
      position = 9;
    }
  }
  sum %= 11;
  if (sum < 2) {
    return '0';
  }
  return (11 - sum).toString();
}

function getDaysInMonth(dateString) {
  // Divide o ano e o mês a partir da string no formato YYYY-MM
  const [year, month] = dateString.split('-').map(Number);

  // Retorna a quantidade de dias no mês (o mês - 1 porque o JavaScript usa índice baseado em zero)
  return new Date(year, month, 0).getDate();
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function generatePrefixIntegracaoNimbus(numIntegracaoLocalidade) {
  return numIntegracaoLocalidade ? `${String(numIntegracaoLocalidade)}0000` : null;
}

function buildChangesForm(oldData, currentData, parserData, cb) {
  const data = parserData(oldData, currentData);
  cb && cb(data);
}

function customDebounce(fn, delay) {
  let timeoutId;
  return {
    execute(...args) {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        fn.apply(this, args);
      }, delay);
    },
    reset() {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = null;
    }
  };
}

function getLotoDataUrl() {
  return process.env.VUE_APP_LOTO_DATA_URL;
}

function formatAddress(address, isCsv = false) {
  if (!address) {
    return null;
  }
  const parserAddress = safeJsonParse(address);
  const formattedAddress = Object.values(parserAddress)
    .map((item) => {
      if (item.trim() === '') {
        return null;
      }
      return item.trim();
    })
    .filter((item) => item !== null)
    .join(', ');
  return isCsv ? formattedAddress.replace(/,/g, ' - ') : formattedAddress;
}

/**
 * Faz o parse seguro de uma string JSON
 * @param {string} jsonString - String JSON para ser parseada
 * @param {any} defaultValue - Valor padrão caso o parse falhe
 * @returns {any} Objeto parseado ou valor padrão
 */
export const safeJsonParse = (jsonString, defaultValue = null) => {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    return defaultValue || jsonString;
  }
};

const utils = {
  checarAcao,
  formatMoney,
  unixToIso2,
  formatCurrency,
  getDateFormat,
  formatDate,
  formatXmlTag,
  compareDifferenceDates,
  isValidCPF,
  isValidCNPJ,
  titleCase,
  abreviate,
  isValidDNI,
  isValidCURP,
  passwordsValidation,
  isValidSSN,
  formatDateTime,
  formatDateByPattern,
  sortArray,
  onlyNumbers,
  getDaysInMonth,
  stringToNumber,
  getTipoUsuario,
  isSameDay,
  translateMetodoPagamento,
  formatPin,
  getEnv,
  makeRandomString,
  gloading,
  dataExport,
  formatDateDB,
  validateDates,
  isValidFileName,
  formataCpf,
  formataCnpj,
  validateDateTime,
  validateTime,
  validateFormEntity,
  formatIdStatusPin,
  percentage,
  pickOrderObj,
  getDateLang,
  dateToOdin,
  formatDateByTimezone,
  debounce,
  customDebounce,
  getTipoTemplateExtrato,
  formWarn,
  formatPhone,
  fixedFloat,
  chunk,
  monthsFromDate,
  removeArrayItem,
  brToFloat,
  isStrengthPassword,
  replaceSpecialChar,
  IsJsonString,
  getIdEmpresa,
  stringToDate,
  converterOdds,
  dateIsBefore,
  cpfValidation,
  emailValidation,
  formatDateWithWeek,
  getTheme,
  setTheme,
  showWeekFromDate,
  checkFileSizeAndName,
  removeItemFromArray,
  unixToIso,
  odinErrorTranslate,
  formatMoneyToFloat,
  trimString,
  validaCotacaoMax,
  buildConfirmModal,
  isRoot,
  getDateTimeStamp,
  isAlphaNumeric,
  switchThemeDark,
  isValidDomain,
  isAdmin,
  isMonitor,
  removeDuplicateByList,
  getUniques,
  objectIsSame,
  removeNulls,
  exportComponent,
  isValidCssUnity,
  isSequential,
  hasSpecialChars,
  getObjectRaw,
  validarPermissaoGestor,
  toLower,
  slugify,
  copyToClipBoard,
  currencyPerLanguage,
  getDetalhesPaises,
  odinToDate,
  emptyColumn,
  downloadFile,
  formatIdStatusBilhete,
  verifyMfa,
  requireMFAForOperation,
  isNullUndefinedOrEmpty,
  rangeColor,
  generateRandomToken,
  generateURLFile,
  formatDateTimeLocal,
  getIdLocalidades,
  getIdsPermissoesNegocios,
  checkCurrentRoute,
  goToRouter,
  getIdsPermissoesNegocios,
  detectarMascaraData,
  removeEmptyFromObj,
  getPerfilBusiness,
  formatStatusBilhetePago,
  formatStatusBilheteMeioPago,
  formatStatusLogin,
  gestorLotericoIsActive,
  renomearChavesEmArray,
  autenticacaoBilheteV2,
  capitalizeFirstLetter,
  mascaraAgencia,
  mascaraContaCorrente,
  union,
  merge,
  formatAddress,
  safeJsonParse,
  generatePrefixIntegracaoNimbus,
  buildChangesForm,
  getLotoDataUrl
};

Vue.prototype.$util = utils;
Vue.prototype.$msg = infoMsgs;
export default utils;
